import { render } from "./TablePun.vue?vue&type=template&id=350baf1f&scoped=true"
import script from "./TablePun.vue?vue&type=script&lang=js"
export * from "./TablePun.vue?vue&type=script&lang=js"

import "./TablePun.vue?vue&type=style&index=0&id=350baf1f&lang=css&scoped=true"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-350baf1f"]])

export default __exports__